<template>
  <div class="tel-ui" slot="icons">
    <a @click="handleTel">
      <i></i>
      <p>联系商家</p>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    tel: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleTel() {
      this.$emit('tel')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.tel-ui {
  width: rem(150px);
  padding: rem(2px) 0;
  padding-left: rem(20px);
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  i {
    width: rem(80px);
    height: rem(52px);
    background: url('~@/assets/images/product/button_icon_lxsj@3x.png')
      no-repeat center top;
    background-size: rem(44px) auto;
  }
  p {
    font-size: rem(20px);
    color: #262626;
    line-height: rem(24px);
  }
}
</style>
